<template>
  <div>
    <!---->
    <b-row>
      <b-col md="5" offset-md="3">
        <b-card no-body class="border mb-1">
          <b-card-body class="p-2 m-0 ">
            <b-card-title class="p-1 m-0 text-center ">
              {{ $t("roadmap.stage.platform-stages-completed") }}
            </b-card-title>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isPlanningStageEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.ddo-planning") }}</b-card-title>

          <content-loading v-if="isPlanningLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionPlanning"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksPlanning" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementDdoRoadmap" stage="DDO_PLANNING" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isApplyEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.ddo-apply") }}</b-card-title>

          <content-loading v-if="isApplyLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionApply"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksApply" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementDdoRoadmap" stage="DDO_APPLY" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isControlAndPreventionEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.ddo-control-and-prevention") }}</b-card-title>

          <content-loading v-if="isControlAndPreventionLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionControlAndPrevention"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksControlAndPrevention" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementDdoRoadmap" stage="DDO_CONTROL_AND_PREVENTION" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="1" offset-md="5" class="text-center"> <i class="bx bx-down-arrow-alt font-size-24 text-muted"></i> </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <b-card no-body class="border mb-1" :class="isChangeManagementEdited ? 'border-warning' : ''">
          <b-card-title class="p-1 m-0 mt-2 text-center ">{{ $t("roadmap.stage.ddo-change-management") }}</b-card-title>

          <content-loading v-if="isChangeManagementLoading" />
          <b-card-body v-else class="p-2 m-0 ">
            <textarea class="form-control" placeholder="Aşama Açıklaması" v-model="descriptionChangeManagement"> </textarea>
            <h5>{{ $t("task.plural") }}</h5>
            <div v-for="task in tasksChangeManagement" :key="task._id" class="card card-body">
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-delete" buttonClass="text-danger hidden float-right" @click="removeTaskItem(task)" />
              <sweet-button :only-icon="true" variant="false" icon="mdi mdi-pencil" buttonClass="text-warning hidden float-right" @click="editTaskItem(task)" />

              <h6>{{ $t("task.name") }}</h6>
              {{ task.name | translate }}
              <h6>{{ $t("task.description") }}</h6>
              {{ task.description | translate }}

              <div v-if="task.blockedByTasks && task.blockedByTasks.length > 0">
                <h6>{{ $t("task.blocked-by") }}</h6>
                <ol>
                  <li v-for="t in task.blockedByTasks" :key="t._id">{{ t.name | translate }}</li>
                </ol>
              </div>
            </div>

            <roadmap-stage-task-form store="managementDdoRoadmap" stage="DDO_CHANGE_MANAGEMENT" />
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <hr />
    <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
      {{ $t("common.save") }}
    </sweet-button>
  </div>
</template>

<script>
import RoadmapStageTaskForm from "./component/roadmap-stage-task-form";
const state = "managementDdoRoadmap";

export default {
  components: { RoadmapStageTaskForm },
  data() {
    return {};
  },

  computed: {
    descriptionPlanning: {
      get() {
        return this.$store.getters[`${state}/descriptionPlanning`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionPlanning`, v);
      },
    },
    descriptionApply: {
      get() {
        return this.$store.getters[`${state}/descriptionApply`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionApply`, v);
      },
    },
    descriptionControlAndPrevention: {
      get() {
        return this.$store.getters[`${state}/descriptionControlAndPrevention`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionControlAndPrevention`, v);
      },
    },
    descriptionChangeManagement: {
      get() {
        return this.$store.getters[`${state}/descriptionChangeManagement`];
      },
      set(v) {
        this.$store.commit(`${state}/descriptionChangeManagement`, v);
      },
    },

    //
    editedStages() {
      return this.$store.getters[`${state}/editedStages`];
    },
    isPlanningStageEdited() {
      return this.editedStages.includes("DDO_PLANNING");
    },
    isApplyEdited() {
      return this.editedStages.includes("DDO_APPLY");
    },
    isControlAndPreventionEdited() {
      return this.editedStages.includes("DDO_CONTROL_AND_PREVENTION");
    },
    isChangeManagementEdited() {
      return this.editedStages.includes("DDO_CHANGE_MANAGEMENT");
    },

    isApplyLoading() {
      return this.$store.getters[`${state}/isApplyLoading`];
    },
    isPlanningLoading() {
      return this.$store.getters[`${state}/isPlanningLoading`];
    },

    isControlAndPreventionLoading() {
      return this.$store.getters[`${state}/isControlAndPreventionLoading`];
    },
    isChangeManagementLoading() {
      return this.$store.getters[`${state}/isChangeManagementLoading`];
    },

    //
    tasks() {
      return this.$store.getters[`${state}/tasks`];
    },
    tasksPlanning() {
      return this.tasks.filter((i) => i.stage == "DDO_PLANNING");
    },
    tasksApply() {
      return this.tasks.filter((i) => i.stage == "DDO_APPLY");
    },
    tasksControlAndPrevention() {
      return this.tasks.filter((i) => i.stage == "DDO_CONTROL_AND_PREVENTION");
    },
    tasksChangeManagement() {
      return this.tasks.filter((i) => i.stage == "DDO_CHANGE_MANAGEMENT");
    },

    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
  },
  mounted() {
    this.loadStages();
    window.addEventListener("beforeunload", this.beforeUnload);
  },
  beforeRouteLeave(to, from, next) {
    const answer = window.confirm("Do you really want to leave? you have unsaved changes!");
    if (answer) {
      next();
    } else {
      next(false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  methods: {
    beforeUnload(e) {
      if (this.editedStages.length == 0) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },

    loadStages() {
      return this.$store.dispatch(`${state}/loadStages`);
    },
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`${state}/save`);
        this.loadStages();
        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        console.error(error);
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    removeTaskItem(task) {
      this.$store.commit(`${state}/removeTaskItem`, { task });
    },
    editTaskItem(task) {
      this.$store.commit(`${state}/editedTask`, { ...task });

      this.$root.$emit("bv::toggle::collapse", `sidebar-create-task-` + task.stage);
    },
  },
};
</script>
